<template>
  <div class="flex flex-col items-center justify-center w-full pt-20">
    <div class="flex items-center gap-2 mb-10 ">
      <img
        src="https://www.insurance4music.eu/wp-content/themes/i4m/images/logo.png"
        class="logo"
        alt="Insurance4Music logo ufficiale"
        width="96"
      />

      <scalapay-logo :width="130"></scalapay-logo>
    </div>

    <vue-loaders name="square-spin" color="#ed8936" scale=".5"></vue-loaders>

    <div class="mt-10 text-xl font-bold text-center">{{ loaderMessage }}</div>
  </div>
</template>

<script>
import api from '@/api.js';

export default {
  name: 'scalapay-result',

  data() {
    return {
      status: null
    };
  },

  mounted() {
    const { orderToken, status, order_code } = this.$route.query;
    this.status = status;

    if (status === 'INIT') {
      api.createScalapayOrder(order_code).then(res => {
        window.location.replace(res.data.checkout_url);
      });
      return;
    }

    if (status === 'SUCCESS') {
      api
        .payScalapayOrder(orderToken)
        .then(res => {
          console.log('res success!', res);
          this.msg('close-success');
        })
        .catch(err => {
          const status = err.response.status;
          const msg = err.response.data.message;

          if (status === 403 || status === 500) {
            window.alert(
              msg || "C'è stato un errore nel completare il pagamento, contatta il supporto."
            );
            this.msg('close-error');
          }
        });
      return;
    }

    //TODO: verify with the server, mark as failed
    this.msg('close-error');
  },

  computed: {
    loaderMessage() {
      if (this.status === 'INIT') return 'Ti stiamo connettendo con Scalapay';
      if (this.status === 'SUCCESS') return 'Effettuando il primo pagamento...';
      return 'OPS';
    }
  },

  methods: {
    msg(event) {
      window.opener.postMessage(
        JSON.stringify({ type: 'scalapay-result', event }),
        process.env.VUE_APP_URL
        // window.location.origin
      );
    }
  }
};
</script>
<style></style>
